(() => {
  const SHOW_DELAY = 200;
  const LOCAL_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  const get = (sel, root = document) => root.querySelector(sel);

  const isVerified = (key, kind) => {
    try {
      if (kind === 'local') {
        const raw = localStorage.getItem(key);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (data && data.t && Date.now() - data.t < LOCAL_TTL_MS) return true;
        localStorage.removeItem(key);
        return false;
      }
      return sessionStorage.getItem(key) === 'true';
    } catch (e) {
      return false;
    }
  };

  const setVerified = (key, kind) => {
    try {
      if (kind === 'local') {
        localStorage.setItem(key, JSON.stringify({ t: Date.now() }));
      } else {
        sessionStorage.setItem(key, 'true');
      }
    } catch (e) {
      /* storage disabled */
    }
  };

  const init = () => {
    const gate = get('[data-age-gate]');
    if (!gate) return;

    const key = gate.dataset.key || 'lb-age-verified';
    // storage_kind is set as a data attribute below — fall back to session
    const kind = gate.dataset.kind || 'session';

    if (isVerified(key, kind)) {
      gate.remove();
      return;
    }

    const card = get('[data-age-gate-card]', gate);
    const stateDefault = get('[data-age-gate-state="default"]', gate);
    const stateDenied = get('[data-age-gate-state="denied"]', gate);
    const accentTop = get('[data-age-gate-accent-top]', gate);
    const accentBottom = get('[data-age-gate-accent-bottom]', gate);
    const confirmBtn = get('[data-age-gate-confirm]', gate);
    const denyBtn = get('[data-age-gate-deny]', gate);

    // Deliberately no entrance animation anywhere in the gate. Fading or
    // transitioning a full-viewport overlay forces continuous whole-screen
    // re-composites that stall first paint ~2s under software rendering
    // (PSI, low-end phones). The gate cuts in, in one frame.
    const show = () => {
      gate.classList.remove('hidden', 'opacity-0');
      gate.classList.add('opacity-100');
      gate.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const hide = () => {
      gate.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      gate.remove();
    };

    const showDenied = () => {
      if (stateDefault) stateDefault.classList.add('hidden');
      if (stateDenied) stateDenied.classList.remove('hidden');
      if (accentTop) {
        accentTop.classList.remove('bg-primary');
        accentTop.classList.add('bg-red-500/60');
      }
      if (accentBottom) {
        accentBottom.classList.remove('bg-primary/40');
        accentBottom.classList.add('bg-red-500/30');
      }
    };

    confirmBtn?.addEventListener('click', () => {
      setVerified(key, kind);
      hide();
    });

    denyBtn?.addEventListener('click', () => {
      showDenied();
    });

    setTimeout(show, SHOW_DELAY);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
